var React = require('react');

function SmallMinus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 7H1c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1z"}));
}

SmallMinus.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = SmallMinus;

SmallMinus.default = SmallMinus;
